import { useInjection } from 'inversify-react';

import { Grid } from '@desygner/ui-common-components';
import { useProjectsStore } from '@desygner/ui-features-projects';

import { VideoManager } from '../../../../../core/viewer/video-manager';
import { VirtualizerService } from '../../../../../core/viewer/virtualizer-service';
import { TYPES } from '../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../store';
import { StyledWrapperPanel } from './ThumbnailsPanel.styles';

export type ThumbnailsPanelProps = {
  open: boolean;
};

export const ThumbnailsPanel = ({ open }: ThumbnailsPanelProps) => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const virtualizerService = useInjection<VirtualizerService>(TYPES.Viewer.VirtualizerService);
  const videoManager = useInjection<VideoManager>(TYPES.Viewer.VideoManager);

  const { project } = useProjectsStore();
  const pagesData = project.currentProject?.pages || [];

  const setSelectedPageNumber = useViewerStore((state) => state.setSelectedPageNumber);
  const selectedPageNumber = useViewerStore((state) => state.selectedPageNumber);

  function handleWheel(event: React.WheelEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  function handleThumbnailClick(pageNumber: number) {
    videoManager.pauseCurrentActiveVideo();
    setSelectedPageNumber(pageNumber);
    virtualizerService.scrollToIndex(pageNumber - 1);
  }

  return (
    <StyledWrapperPanel data-testid="thumbnails-panel" open={open} onWheel={handleWheel}>
      <Grid
        cardType="image"
        assetType="image"
        draggable={false}
        isQa
        items={pagesData.map((page) => {
          return {
            source: page.thumbnail as string,
            alt: page.page_number?.toString(),
            active: selectedPageNumber === page.page_number,
            data: page.page_number?.toString(),
            title: page.page_number?.toString(),
            variant: 'thumbnail',
            badge: videoManager.getTotalDurationOfAllVideosInPage(page.id),
          };
        })}
        onClick={({ details: pageNumber }) => handleThumbnailClick(Number(pageNumber))}
        columns={1}
      />
    </StyledWrapperPanel>
  );
};
